import { qCardCertificatesActions } from "./qCardCertificates-slice";
import { uiActions } from "./ui-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchQCardData = (url_data, token) => {
	return async (dispatch) => {
		dispatch(uiActions.showLoadingSpinner(2));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const qCardData = await fetchData();
			dispatch(qCardCertificatesActions.updateQCard(qCardData));
			dispatch(uiActions.hideLoadingSpinner(2));
		} catch (error) {
			console.log(error);
		}
	};
};
